import { FC } from 'react'

import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import useTOTPBlock from '$actions/useTOTPBlock'

import {
  description as descriptionStyle,
  header,
  title as titleStyle
} from '$blocks/common/auth.css'
import OTPInput from '$elements/OTPInput'
import VirtualOTPForm from '$elements/VirtualOTPForm'

import { otp } from './styles.css'

export type TOTPBlockProps = ReturnType<typeof useTOTPBlock>

export const TOTPBlock: FC<TOTPBlockProps> = ({
  otpInput,
  title,
  description
}) => {
  const otpInputProps = {
    ...otpInput,
    passwordFieldProps: {
      ...otpInput.passwordFieldProps,
      inputProps: propsWithClassNames(
        otpInput.passwordFieldProps.inputProps,
        otp.input
      )
    }
  }

  return (
    <>
      <header className={header}>
        <h2 className={titleStyle}>{title}</h2>

        <p className={descriptionStyle}>{description}</p>
      </header>

      <main className={otp.main}>
        <VirtualOTPForm>
          <OTPInput {...otpInputProps} />
        </VirtualOTPForm>
      </main>
    </>
  )
}

export default TOTPBlock
